import React from 'react';

function MInput({placeholder, value, setValue, type = 'text', error, name, ...props}) {
    return (
        <>
            <input
                type={type}
                placeholder={placeholder}
                value={value}
                name={name}
                onChange={setValue}
                className={`p-3 border border-gray-400 rounded-xl m-1 ${error && 'border-2 border-red-700'} ${props.className}`}
            />
        </>
    );
}

export default MInput;
